type ConditionsType = {
	[x: string]: boolean;
};

const classNames = (conditions: ConditionsType): string => {
	const classes: string[] = [];

	Object.keys(conditions).forEach((key) => {
		const condition = conditions[key];
		if (condition) classes.push(key);
	});

	return classes.join(" ");
};

export default classNames;
